import { Injectable } from "@angular/core";

@Injectable()
export class StorageService {
  addAlertMessageInSessionStorage(message: any) {
    const alertMessage = sessionStorage.getItem("alertMessage");
    if (alertMessage) {
      sessionStorage.removeItem("alertMessage");
    } else {
      sessionStorage.setItem("alertMessage", JSON.stringify(message));
    }
  }
  removeAlertMessageInSessionStorage() {
    const alertMessage = sessionStorage.getItem("alertMessage");
    if (alertMessage) {
      sessionStorage.removeItem("alertMessage");
    }
  }
  getAlertMessageFromSessionStorage(): any {
    const existingItem = sessionStorage.getItem("alertMessage");
    let alertMessage = existingItem ? JSON.parse(existingItem) : null;
    return alertMessage;
  }
}
